import React from 'react';
import { AppState } from '../../redux/reducers';
import { connect } from 'react-redux';
import Ticket from '../../redux/models/Ticket';
import './HelpDeskMainTicketRow';
import HelpDeskMainTicketRow from './HelpDeskMainTicketRow';
import Page from '../Page';
import PageHeaderItem from '../PageHeaderItem';
import PageHeader from '../PageHeader';
import HelpDeskMainTicketsTable from './HelpDeskMainTicketsTable';

interface Props {
    tickets: Array<Ticket>;
}

const HelpDeskPausedTickets: React.FunctionComponent<Props> = (props: Props) => (
    <Page>
        <PageHeader title='Tickets Pausados'>
            <PageHeaderItem title='Dashboard' link='/dashboard' active={false} />
            <PageHeaderItem title='Tickets Pausados' link='/paused_tickets' active={true} />
        </PageHeader>
        <HelpDeskMainTicketsTable title='Tickets Recientes'>
            <tbody>
                {props.tickets.map(ticket => (
                    <HelpDeskMainTicketRow key={ticket.id} ticket={ticket} />
                ))}
            </tbody>
        </HelpDeskMainTicketsTable>
    </Page>
);

const mapStateToProps = (state: AppState): Props => ({
    tickets: state.tickets
        .filter(ticket => ticket.paused && !ticket.closed)
        .toList()
        .toArray()
        .sort((ticketOne, ticketTwo) => (parseInt(ticketOne.id.slice(4)) < parseInt(ticketTwo.id.slice(4)) ? 1 : -1))
});

export default connect(mapStateToProps)(React.memo(HelpDeskPausedTickets));
